import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeader } from 'shared/ui/PageHeader';
import { ExtensionsWidget } from 'widgets/Extensions';
import { PageWrapper } from 'pages/_layouts/PageWrapper';

export const Extensions: FC = () => {
	const { t } = useTranslation();
	return (
		<PageWrapper>
			<PageHeader title={t('extensions.ex_title')} description={t('extensions.ex_description')} />
			<ExtensionsWidget />
		</PageWrapper>
	);
};
